var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",style:({ backgroundImage: `url('${_vm.backgroundImg}'), ${_vm.backgroundImgStyle}` })},[_c('div',{staticClass:"banner-content"},[_c('div',{staticClass:"banner-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"banner-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }